
var dt = [
		{label:'Phone call', value:'Phone call', icon:'ri-phone-line'},
		{label:'Email', value:'Email', icon:'ri-mail-line'},
		{label:'Other', value:'Other', icon:'ri-speak-line'},
	];


export default dt;